import React, { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { DatePicker, Form, Input } from "antd";
import { SimpleInput } from "../../../../common/components/simpleInput";
import style from "./style.module.scss";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../utilities/API_URLs";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import { MissingService } from "../core/_request";
import { HttpStatusCode } from "axios";

type MissingFormType = {
  onFinish: () => void;
  initialValue?: any;
};
export const MissingForm = ({ onFinish, initialValue }: MissingFormType) => {
  const [form] = Form.useForm();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue) {
      console.log(initialValue);
      const formatedData = {
        ...initialValue,
        absenceType: initialValue?.absenceType
          ? {
              label: initialValue?.absenceType?.name,
              value: initialValue?.absenceType?.["@id"],
            }
          : null,
        staff:
          typeof initialValue?.staff === "object"
            ? {
                label: initialValue?.staff?.fullname,
                value: initialValue?.staff?.["@id"],
              }
            : initialValue?.staff,
        date:
          initialValue?.startAt && initialValue?.endAt
            ? [
                dayjs(initialValue?.startAt, "DD/MM/YYYY HH:mm"),
                dayjs(initialValue?.endAt, "DD/MM/YYYY HH:mm"),
              ]
            : [],
      };

      form.setFieldsValue(formatedData);
    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);

      const formatedData = {
        ...(values?.id ? { id: values?.id } : {}),
        absenceType: values?.absenceType ? values?.absenceType?.value : null,
        staff: values?.staff ? values?.staff?.value : null,
        ...(values?.date
          ? {
              startAt: dayjs(values?.date?.[0]).format("YYYY-MM-DD HH:mm"),
              endAt: dayjs(values?.date?.[1]).format("YYYY-MM-DD HH:mm"),
            }
          : {}),
        reason: values?.reason,
      };

      if (!formatedData?.id) {
        // Ajout
        const { status } = await MissingService.createMissing(formatedData);

        if (status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        // Edit
        const { status } = await MissingService.updateMissing(formatedData);

        if (status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (_: any) {
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>

        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Type d'absence"
                name={"absenceType"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <InputSelect
                    uri={`${API_URLs.missing.typeSelect}`}
                    onChange={(e) => {
                      console.log(e);
                    }}
                  />
                }
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Employée"
                name={"staff"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <InputSelect
                    valueOption={{
                      labelKey: "fullname",
                      valueKey: "@id",
                    }}
                    uri={`${API_URLs.staff.getStaffForSelect}`}
                    onChange={(e) => {
                      console.log(e);
                    }}
                  />
                }
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Date"
                name={"date"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <DatePicker.RangePicker
                    className=""
                    format={"DD/MM/YYYY HH:mm"}
                    placeholder={["Début", "Fin"]}
                    showTime
                    // value={
                    //   request?.periodStart && request?.periodEnd
                    //     ? [dayjs(request?.periodStart), dayjs(request?.periodEnd)]
                    //     : [null, null]
                    // }
                    onChange={(e) => {
                      console.log(e);
                    }}
                    needConfirm={false}
                  />
                }
              />
            </div>
          </div>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Raison"
                name={"reason"}
                // rules={[
                //   {
                //     required: true,
                //     message: `Ce champ est requis`,
                //   },
                // ]}
                customInput={
                  <TextArea
                    onChange={(e) => {
                      console.log(e);
                    }}
                  />
                }
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}></div>
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
